import React, { createContext, useContext, useMemo, useState } from "react";

const DataContext = createContext();

export function DataProvider({ children }) {
  const [data, setData] = useState([]);

  const value = useMemo(
    () => ({
      data,
      setData,
    }),
    [data],
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}

export const useDataContext = () => useContext(DataContext);
